export const seedRoutes = {
  obterValores: '/values',
  obterValoresMatriz: '/values-matrix',
};
